import React from 'react';
import '../../scss/reusables/entries.scss';
import Dropdown from '../Reusables/Dropdown';
import { useEffect, useState } from 'react';

function Entries(props) {
    const {handleEntryDropdown, page} = props;
    const [entryLabel, setEntryLabel] = useState('30');
    const [entryList, setEntryList] = useState([]);

    useEffect(() => {
        setEntryList([
            {id: 1, name: 10}, 
            {id: 2, name: 30},
            {id: 3, name: 50},
            {id: 4, name: 100}
        ])

        if(page == "Projects" || page =="Projects Reports") {
            setEntryLabel(30);
        }
    }, [page])

    return (
        <>
            <div className='entries-container'>
                <label>Entries per page</label>
                <div>
                    <Dropdown label={entryLabel} selectedItem={(name, id) => handleEntryDropdown(name)}
                        handleLabel={(value) => setEntryLabel(value)} list={entryList} enable={true}/>
                </div>
            </div>
        </>
    )
}

export default Entries;